export default __webpack_public_path__ + "static/media/login_bg2.492dfb66.png";